import React from 'react';
import { Button } from '@mui/material';
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Draggable from 'react-draggable';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../dialog/BootstrapDialog';
import ApprovalLineForm from '../../../projectmng/bill_mng/ApprovalLineForm';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-approval-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const ApprovalLineModal = ({
  title,
  open,
  handleClose,
  apprUuid,
  approvalLines,
  handleSubmit,
}) => {
  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-project-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-project-dialog"
        onClose={handleClose}
      >
        {title}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <ApprovalLineForm approvalLines={approvalLines} />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            handleClose();
            handleSubmit();
          }}
        >
          요청완료
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ApprovalLineModal;
